/** Length of SMS/email OTP and TOTP codes issued by member-api. */
export const OTP_LENGTH = 6;

export function isOtpComplete(value: string, length = OTP_LENGTH): boolean {
  return value.length === length && /^\d+$/.test(value);
}
